import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { getSummaryValue, buildDisplayPairRow, makeModelTable } from '../utils'
import { formatScientific } from '@/utils/formatters'
import { getPredictionDataBySource } from '@/components/combined-predict/models/epiSuite/utils'

const summaryMapper = (item, meta) => {
  const rows = (meta?.children ?? []).map((child) => {
    const value = getPredictionDataBySource(item, child.id)

    const description = child?.coefficientKey
      ? `Kp = ${formatScientific(getPredictionDataBySource(item, child?.coefficientKey))} m³/μg`
      : null

    return buildDisplayPairRow({ value: child?.name, belowText: description }, value)
  })

  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, 'Mackay Model')

  return {
    values: [selectedValue],
    tables: [
      {
        headers: ['', 'φ (phi)'],
        rows,
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: [makeModelTable(item?.predicted?.model)],
})

const aeroWin = (items) => {
  const item = items?.find((i) => i?.property === 'aerosolAdsorptionFraction')
  const meta = findEpiSuiteGroupById('aerosolAdsorptionFraction')

  return {
    title: meta?.name,
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: summaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item),
  }
}

export { aeroWin }
